import { render, staticRenderFns } from "./genericTextModal.vue?vue&type=template&id=d45fb2c0"
import script from "./genericTextModal.vue?vue&type=script&lang=js"
export * from "./genericTextModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports